(function ($, undefined) {

    var smapi = window.smapi = window.smapi || {},
        extend = $.extend,
        each = $.each,
        proxy = $.proxy,
        noop = $.noop,
        isFunction = $.isFunction,
        globalize = window.Globalize;

    if (typeof smapi.communication === "undefined") {
        extend(smapi, { communication: {} });
    }

    function AddressTypeAssociationPriorityModel(options) {
        var defaults = {
            Priority: 0,
            AddressAssociationID: 0,
            CommunicationStepID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Priority = ko.validatedObservable(settings.Priority);
        this.AddressAssociationID = ko.validatedObservable(settings.AddressAssociationID);
        this.CommunicationStepID = ko.validatedObservable(settings.CommunicationStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.AddressAssociation = ko.observable();
        this.CommunicationStep = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Priority != undefined) {
                loaded.Priority(responseData.Priority);
            }
            if (responseData.AddressAssociationID != undefined) {
                loaded.AddressAssociationID(responseData.AddressAssociationID);
            }
            if (responseData.CommunicationStepID != undefined) {
                loaded.CommunicationStepID(responseData.CommunicationStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AddressAssociation != null) {
                loaded.AddressAssociation(new smapi.community.AddressAssociationModel().LoadFromResponse(responseData.AddressAssociation));
            }
            if (responseData.CommunicationStep != null) {
                loaded.CommunicationStep(new smapi.communication.CommunicationStepModel().LoadFromResponse(responseData.CommunicationStep));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.AddressTypeAssociationPriority', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Priority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressAssociationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationStepID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CampusVisitStepModel(options) {
        var defaults = {
            Subject: '',
            Instructions: '',
            ConfigurationRuleSetID: null,
            Name: '',
            Description: '',
            SortOrder: 0,
            InteractionStepType: null,
            DurationBeforeExecution: null,
            BeginDate: null,
            EndDate: null,
            InteractionPlanID: null,
            ParentStepID: null,
            InclusionRuleSetID: null,
            BusinessMeaningName: '',
            PathToRecipient: '',
            PathToRecipientExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Subject = ko.validatedObservable(settings.Subject);
        this.Instructions = ko.validatedObservable(settings.Instructions);
        this.ConfigurationRuleSetID = ko.validatedObservable(settings.ConfigurationRuleSetID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.InteractionStepType = ko.validatedObservable(settings.InteractionStepType);
        this.DurationBeforeExecution = ko.validatedObservable(settings.DurationBeforeExecution);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PathToRecipient = ko.validatedObservable(settings.PathToRecipient);
        this.PathToRecipientExpressionID = ko.validatedObservable(settings.PathToRecipientExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlan = ko.observable();
        this.ParentStep = ko.observable();
        this.ChildSteps = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Subject != undefined) {
                loaded.Subject(responseData.Subject);
            }
            if (responseData.Instructions != undefined) {
                loaded.Instructions(responseData.Instructions);
            }
            if (responseData.ConfigurationRuleSetID != undefined) {
                loaded.ConfigurationRuleSetID(responseData.ConfigurationRuleSetID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.InteractionStepType != undefined) {
                loaded.InteractionStepType(responseData.InteractionStepType);
            }
            if (responseData.DurationBeforeExecution != undefined) {
                loaded.DurationBeforeExecution(responseData.DurationBeforeExecution);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PathToRecipient != undefined) {
                loaded.PathToRecipient(responseData.PathToRecipient);
            }
            if (responseData.PathToRecipientExpressionID != undefined) {
                loaded.PathToRecipientExpressionID(responseData.PathToRecipientExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.ParentStep != null) {
                loaded.ParentStep(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ParentStep));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CampusVisitStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Subject.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Instructions.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ConfigurationRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionStepType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToRecipient.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToRecipientExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationFulfillmentFolderModel(options) {
        var defaults = {
            Foldername: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Foldername = ko.validatedObservable(settings.Foldername);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Foldername != undefined) {
                loaded.Foldername(responseData.Foldername);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationFulfillmentFolder', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Foldername.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationRecipientDetailModel(options) {
        var defaults = {
            ToAddress: '',
            ToDisplay: '',
            ContactID: 0,
            CommunicationTypeID: 0,
            RecipientType: null,
            Received: false,
            ReceivedDate: null,
            TargetUserID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.ToAddress = ko.validatedObservable(settings.ToAddress);
        this.ToDisplay = ko.validatedObservable(settings.ToDisplay);
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.CommunicationTypeID = ko.validatedObservable(settings.CommunicationTypeID);
        this.RecipientType = ko.validatedObservable(settings.RecipientType);
        this.Received = ko.validatedObservable(settings.Received);
        this.ReceivedDate = ko.validatedObservable(settings.ReceivedDate);
        this.TargetUserID = ko.validatedObservable(settings.TargetUserID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.CommunicationType = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.ToAddress != undefined) {
                loaded.ToAddress(responseData.ToAddress);
            }
            if (responseData.ToDisplay != undefined) {
                loaded.ToDisplay(responseData.ToDisplay);
            }
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.CommunicationTypeID != undefined) {
                loaded.CommunicationTypeID(responseData.CommunicationTypeID);
            }
            if (responseData.RecipientType != undefined) {
                loaded.RecipientType(responseData.RecipientType);
            }
            if (responseData.Received != undefined) {
                loaded.Received(responseData.Received);
            }
            if (responseData.ReceivedDate != undefined) {
                loaded.ReceivedDate(responseData.ReceivedDate);
            }
            if (responseData.TargetUserID != undefined) {
                loaded.TargetUserID(responseData.TargetUserID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.CommunicationType != null) {
                loaded.CommunicationType(new smapi.communication.CommunicationTypeModel().LoadFromResponse(responseData.CommunicationType));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationRecipientDetail', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.ToAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ToDisplay.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RecipientType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ReceivedDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.TargetUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            SystemProtected: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SystemProtected.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationStepModel(options) {
        var defaults = {
            FromAddress: '',
            FromDisplayName: '',
            WaitForFulfillment: false,
            DurationBeforeEscalation: null,
            RequiresResponseBeforeContinuing: false,
            CommunicationTemplateID: null,
            EscalationStepID: null,
            CommunicationTypeID: 0,
            CommunicationPriorityID: null,
            TrackingCode: '',
            FulfillByGroupID: null,
            LetterCode: '',
            StepTestMode: false,
            ReadTrackingCode: '',
            TargetGroupID: null,
            TargetBindingPath: '',
            Name: '',
            Description: '',
            SortOrder: 0,
            InteractionStepType: null,
            DurationBeforeExecution: null,
            BeginDate: null,
            EndDate: null,
            InteractionPlanID: null,
            ParentStepID: null,
            InclusionRuleSetID: null,
            BusinessMeaningName: '',
            PathToRecipient: '',
            PathToRecipientExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.FromAddress = ko.validatedObservable(settings.FromAddress);
        this.FromDisplayName = ko.validatedObservable(settings.FromDisplayName);
        this.WaitForFulfillment = ko.validatedObservable(settings.WaitForFulfillment);
        this.DurationBeforeEscalation = ko.validatedObservable(settings.DurationBeforeEscalation);
        this.RequiresResponseBeforeContinuing = ko.validatedObservable(settings.RequiresResponseBeforeContinuing);
        this.CommunicationTemplateID = ko.validatedObservable(settings.CommunicationTemplateID);
        this.EscalationStepID = ko.validatedObservable(settings.EscalationStepID);
        this.CommunicationTypeID = ko.validatedObservable(settings.CommunicationTypeID);
        this.CommunicationPriorityID = ko.validatedObservable(settings.CommunicationPriorityID);
        this.TrackingCode = ko.validatedObservable(settings.TrackingCode);
        this.FulfillByGroupID = ko.validatedObservable(settings.FulfillByGroupID);
        this.LetterCode = ko.validatedObservable(settings.LetterCode);
        this.StepTestMode = ko.validatedObservable(settings.StepTestMode);
        this.ReadTrackingCode = ko.validatedObservable(settings.ReadTrackingCode);
        this.TargetGroupID = ko.validatedObservable(settings.TargetGroupID);
        this.TargetBindingPath = ko.validatedObservable(settings.TargetBindingPath);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.InteractionStepType = ko.validatedObservable(settings.InteractionStepType);
        this.DurationBeforeExecution = ko.validatedObservable(settings.DurationBeforeExecution);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PathToRecipient = ko.validatedObservable(settings.PathToRecipient);
        this.PathToRecipientExpressionID = ko.validatedObservable(settings.PathToRecipientExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.EscalationStep = ko.observable();
        this.CommunicationType = ko.observable();
        this.CommunicationTemplate = ko.observable();
        this.RecipientList = ko.observableArray([]);
        this.TargetAddressAssociations = ko.observableArray([]);
        this.Attachments = ko.observableArray([]);
        this.InteractionPlan = ko.observable();
        this.ParentStep = ko.observable();
        this.ChildSteps = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.FromAddress != undefined) {
                loaded.FromAddress(responseData.FromAddress);
            }
            if (responseData.FromDisplayName != undefined) {
                loaded.FromDisplayName(responseData.FromDisplayName);
            }
            if (responseData.WaitForFulfillment != undefined) {
                loaded.WaitForFulfillment(responseData.WaitForFulfillment);
            }
            if (responseData.DurationBeforeEscalation != undefined) {
                loaded.DurationBeforeEscalation(responseData.DurationBeforeEscalation);
            }
            if (responseData.RequiresResponseBeforeContinuing != undefined) {
                loaded.RequiresResponseBeforeContinuing(responseData.RequiresResponseBeforeContinuing);
            }
            if (responseData.CommunicationTemplateID != undefined) {
                loaded.CommunicationTemplateID(responseData.CommunicationTemplateID);
            }
            if (responseData.EscalationStepID != undefined) {
                loaded.EscalationStepID(responseData.EscalationStepID);
            }
            if (responseData.CommunicationTypeID != undefined) {
                loaded.CommunicationTypeID(responseData.CommunicationTypeID);
            }
            if (responseData.CommunicationPriorityID != undefined) {
                loaded.CommunicationPriorityID(responseData.CommunicationPriorityID);
            }
            if (responseData.TrackingCode != undefined) {
                loaded.TrackingCode(responseData.TrackingCode);
            }
            if (responseData.FulfillByGroupID != undefined) {
                loaded.FulfillByGroupID(responseData.FulfillByGroupID);
            }
            if (responseData.LetterCode != undefined) {
                loaded.LetterCode(responseData.LetterCode);
            }
            if (responseData.StepTestMode != undefined) {
                loaded.StepTestMode(responseData.StepTestMode);
            }
            if (responseData.ReadTrackingCode != undefined) {
                loaded.ReadTrackingCode(responseData.ReadTrackingCode);
            }
            if (responseData.TargetGroupID != undefined) {
                loaded.TargetGroupID(responseData.TargetGroupID);
            }
            if (responseData.TargetBindingPath != undefined) {
                loaded.TargetBindingPath(responseData.TargetBindingPath);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.InteractionStepType != undefined) {
                loaded.InteractionStepType(responseData.InteractionStepType);
            }
            if (responseData.DurationBeforeExecution != undefined) {
                loaded.DurationBeforeExecution(responseData.DurationBeforeExecution);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PathToRecipient != undefined) {
                loaded.PathToRecipient(responseData.PathToRecipient);
            }
            if (responseData.PathToRecipientExpressionID != undefined) {
                loaded.PathToRecipientExpressionID(responseData.PathToRecipientExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EscalationStep != null) {
                loaded.EscalationStep(new smapi.communication.CommunicationStepModel().LoadFromResponse(responseData.EscalationStep));
            }
            if (responseData.CommunicationType != null) {
                loaded.CommunicationType(new smapi.communication.CommunicationTypeModel().LoadFromResponse(responseData.CommunicationType));
            }
            if (responseData.CommunicationTemplate != null) {
                loaded.CommunicationTemplate(new smapi.communication.CommunicationTemplateModel().LoadFromResponse(responseData.CommunicationTemplate));
            }
            if (responseData.RecipientList != null && responseData.RecipientList.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.RecipientList.length; i++) {
                    items.push(new smapi.communication.CommunicationRecipientDetailModel().LoadFromResponse(responseData.RecipientList[i]));
                }
                loaded.RecipientList(items);
            }
            if (responseData.TargetAddressAssociations != null && responseData.TargetAddressAssociations.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.TargetAddressAssociations.length; i++) {
                    items.push(new smapi.communication.AddressTypeAssociationPriorityModel().LoadFromResponse(responseData.TargetAddressAssociations[i]));
                }
                loaded.TargetAddressAssociations(items);
            }
            if (responseData.Attachments != null && responseData.Attachments.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Attachments.length; i++) {
                    items.push(new smapi.communication.CommunicationTemplateModel().LoadFromResponse(responseData.Attachments[i]));
                }
                loaded.Attachments(items);
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.ParentStep != null) {
                loaded.ParentStep(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ParentStep));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.FromAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FromDisplayName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.WaitForFulfillment.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RequiresResponseBeforeContinuing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CommunicationTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EscalationStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationPriorityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TrackingCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.FulfillByGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LetterCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.StepTestMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ReadTrackingCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.TargetGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TargetBindingPath.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionStepType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToRecipient.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToRecipientExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationTemplateModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            TokenSeparator: '',
            Html: '',
            FileName: '',
            FileSize: 0,
            LastModified: 0,
            ServerFileUNC: '',
            ReportingServicesReport: '',
            CommunicationTypeID: 0,
            TrackingCode: 0,
            BeginDate: null,
            EndDate: null,
            Subject: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.TokenSeparator = ko.validatedObservable(settings.TokenSeparator);
        this.Html = ko.validatedObservable(settings.Html);
        this.FileName = ko.validatedObservable(settings.FileName);
        this.FileSize = ko.validatedObservable(settings.FileSize);
        this.LastModified = ko.validatedObservable(settings.LastModified);
        this.ServerFileUNC = ko.validatedObservable(settings.ServerFileUNC);
        this.ReportingServicesReport = ko.validatedObservable(settings.ReportingServicesReport);
        this.CommunicationTypeID = ko.validatedObservable(settings.CommunicationTypeID);
        this.TrackingCode = ko.validatedObservable(settings.TrackingCode);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.Subject = ko.validatedObservable(settings.Subject);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.CommunicationType = ko.observable();
        this.TokenList = ko.observableArray([]);
        this.EmbeddedAttachments = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.TokenSeparator != undefined) {
                loaded.TokenSeparator(responseData.TokenSeparator);
            }
            if (responseData.Html != undefined) {
                loaded.Html(responseData.Html);
            }
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.FileSize != undefined) {
                loaded.FileSize(responseData.FileSize);
            }
            if (responseData.LastModified != undefined) {
                loaded.LastModified(responseData.LastModified);
            }
            if (responseData.ServerFileUNC != undefined) {
                loaded.ServerFileUNC(responseData.ServerFileUNC);
            }
            if (responseData.ReportingServicesReport != undefined) {
                loaded.ReportingServicesReport(responseData.ReportingServicesReport);
            }
            if (responseData.CommunicationTypeID != undefined) {
                loaded.CommunicationTypeID(responseData.CommunicationTypeID);
            }
            if (responseData.TrackingCode != undefined) {
                loaded.TrackingCode(responseData.TrackingCode);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.Subject != undefined) {
                loaded.Subject(responseData.Subject);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CommunicationType != null) {
                loaded.CommunicationType(new smapi.communication.CommunicationTypeModel().LoadFromResponse(responseData.CommunicationType));
            }
            if (responseData.TokenList != null && responseData.TokenList.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.TokenList.length; i++) {
                    items.push(new smapi.communication.CommunicationTokenModel().LoadFromResponse(responseData.TokenList[i]));
                }
                loaded.TokenList(items);
            }
            if (responseData.EmbeddedAttachments != null && responseData.EmbeddedAttachments.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.EmbeddedAttachments.length; i++) {
                    items.push(new smapi.communication.CommunicationTemplateEmbeddedAttachmentModel().LoadFromResponse(responseData.EmbeddedAttachments[i]));
                }
                loaded.EmbeddedAttachments(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationTemplate', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TokenSeparator.extend({
            maxLength: {
                params: 5,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '5')
            }
        });
        this.FileName.extend({
            pattern: {
                params: /^(?:[\w]\:|\\|[\w\W])((\\*)[\w\W-[\\<>:\"\|\?\*]]+)+\.[\w\W-[\\<>:\"\|\?\*]]+$/,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_IncorrectFormat_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FileSize.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LastModified.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ServerFileUNC.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.ReportingServicesReport.extend({
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.CommunicationTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TrackingCode.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Subject.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationTemplateEmbeddedAttachmentModel(options) {
        var defaults = {
            FileName: '',
            FileEncoding: '',
            FileSize: 0,
            MIMEType: '',
            FileData: null,
            CommunicationTemplateID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.FileEncoding = ko.validatedObservable(settings.FileEncoding);
        this.FileSize = ko.validatedObservable(settings.FileSize);
        this.MIMEType = ko.validatedObservable(settings.MIMEType);
        this.FileData = ko.validatedObservable(settings.FileData);
        this.CommunicationTemplateID = ko.validatedObservable(settings.CommunicationTemplateID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.CommunicationTemplate = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.FileEncoding != undefined) {
                loaded.FileEncoding(responseData.FileEncoding);
            }
            if (responseData.FileSize != undefined) {
                loaded.FileSize(responseData.FileSize);
            }
            if (responseData.MIMEType != undefined) {
                loaded.MIMEType(responseData.MIMEType);
            }
            if (responseData.FileData != undefined) {
                loaded.FileData(responseData.FileData);
            }
            if (responseData.CommunicationTemplateID != undefined) {
                loaded.CommunicationTemplateID(responseData.CommunicationTemplateID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CommunicationTemplate != null) {
                loaded.CommunicationTemplate(new smapi.communication.CommunicationTemplateModel().LoadFromResponse(responseData.CommunicationTemplate));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationTemplateEmbeddedAttachment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.FileEncoding.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FileSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MIMEType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CommunicationTemplateID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationTokenModel(options) {
        var defaults = {
            Token: '',
            TokenExpressionID: null,
            ApplicationSettingID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Token = ko.validatedObservable(settings.Token);
        this.TokenExpressionID = ko.validatedObservable(settings.TokenExpressionID);
        this.ApplicationSettingID = ko.validatedObservable(settings.ApplicationSettingID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Token != undefined) {
                loaded.Token(responseData.Token);
            }
            if (responseData.TokenExpressionID != undefined) {
                loaded.TokenExpressionID(responseData.TokenExpressionID);
            }
            if (responseData.ApplicationSettingID != undefined) {
                loaded.ApplicationSettingID(responseData.ApplicationSettingID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationToken', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Token.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.TokenExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationSettingID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationTrackingModel(options) {
        var defaults = {
            TrackingCode: '',
            PersonName: '',
            CommunicationPlanStepName: '',
            TrackingInstanceID: null,
            CreateDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.TrackingCode = ko.validatedObservable(settings.TrackingCode);
        this.PersonName = ko.validatedObservable(settings.PersonName);
        this.CommunicationPlanStepName = ko.validatedObservable(settings.CommunicationPlanStepName);
        this.TrackingInstanceID = ko.validatedObservable(settings.TrackingInstanceID);
        this.CreateDate = ko.validatedObservable(settings.CreateDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.TrackingCode != undefined) {
                loaded.TrackingCode(responseData.TrackingCode);
            }
            if (responseData.PersonName != undefined) {
                loaded.PersonName(responseData.PersonName);
            }
            if (responseData.CommunicationPlanStepName != undefined) {
                loaded.CommunicationPlanStepName(responseData.CommunicationPlanStepName);
            }
            if (responseData.TrackingInstanceID != undefined) {
                loaded.TrackingInstanceID(responseData.TrackingInstanceID);
            }
            if (responseData.CreateDate != undefined) {
                loaded.CreateDate(responseData.CreateDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationTracking', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.TrackingCode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.PersonName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CommunicationPlanStepName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TrackingInstanceID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.CreateDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function CommunicationTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EditorControlToUse: '',
            DisplayControlToUse: '',
            MergeEngine: '',
            BusinessMeaningName: '',
            AddressBusinessMeaningName: '',
            AvailableForPortalApplicants: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EditorControlToUse = ko.validatedObservable(settings.EditorControlToUse);
        this.DisplayControlToUse = ko.validatedObservable(settings.DisplayControlToUse);
        this.MergeEngine = ko.validatedObservable(settings.MergeEngine);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.AddressBusinessMeaningName = ko.validatedObservable(settings.AddressBusinessMeaningName);
        this.AvailableForPortalApplicants = ko.validatedObservable(settings.AvailableForPortalApplicants);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EditorControlToUse != undefined) {
                loaded.EditorControlToUse(responseData.EditorControlToUse);
            }
            if (responseData.DisplayControlToUse != undefined) {
                loaded.DisplayControlToUse(responseData.DisplayControlToUse);
            }
            if (responseData.MergeEngine != undefined) {
                loaded.MergeEngine(responseData.MergeEngine);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.AddressBusinessMeaningName != undefined) {
                loaded.AddressBusinessMeaningName(responseData.AddressBusinessMeaningName);
            }
            if (responseData.AvailableForPortalApplicants != undefined) {
                loaded.AvailableForPortalApplicants(responseData.AvailableForPortalApplicants);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.CommunicationType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EditorControlToUse.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DisplayControlToUse.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MergeEngine.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AddressBusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function ContactCommunicationModel(options) {
        var defaults = {
            Subject: '',
            FromAddress: '',
            ToAddress: '',
            FromDisplay: '',
            ToDisplay: '',
            Html: '',
            Fulfilled: false,
            FulfilledDate: null,
            WaitingForResponse: false,
            ReceivedResponse: false,
            ResponseDate: null,
            Received: false,
            ReceivedDate: null,
            InteractionPlanInstanceID: null,
            CommunicationTypeID: 0,
            ContactID: 0,
            RelatedContactID: null,
            CommunicationStepID: null,
            ParentCommunicationID: null,
            FileName: '',
            CommunicationPriorityID: null,
            InitiatedByUserID: null,
            InitiatedByGroupID: null,
            FulfilledByUserID: null,
            FulfilledByGroupID: null,
            TargetUserID: null,
            ReadReceipt: false,
            ActionTaken: false,
            ReadTrackingCode: '',
            TrackingCode: '',
            BroadcastIdentifier: '',
            CommunicationStatusID: 0,
            StatusMessage: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Subject = ko.validatedObservable(settings.Subject);
        this.FromAddress = ko.validatedObservable(settings.FromAddress);
        this.ToAddress = ko.validatedObservable(settings.ToAddress);
        this.FromDisplay = ko.validatedObservable(settings.FromDisplay);
        this.ToDisplay = ko.validatedObservable(settings.ToDisplay);
        this.Html = ko.validatedObservable(settings.Html);
        this.Fulfilled = ko.validatedObservable(settings.Fulfilled);
        this.FulfilledDate = ko.validatedObservable(settings.FulfilledDate);
        this.WaitingForResponse = ko.validatedObservable(settings.WaitingForResponse);
        this.ReceivedResponse = ko.validatedObservable(settings.ReceivedResponse);
        this.ResponseDate = ko.validatedObservable(settings.ResponseDate);
        this.Received = ko.validatedObservable(settings.Received);
        this.ReceivedDate = ko.validatedObservable(settings.ReceivedDate);
        this.InteractionPlanInstanceID = ko.validatedObservable(settings.InteractionPlanInstanceID);
        this.CommunicationTypeID = ko.validatedObservable(settings.CommunicationTypeID);
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.RelatedContactID = ko.validatedObservable(settings.RelatedContactID);
        this.CommunicationStepID = ko.validatedObservable(settings.CommunicationStepID);
        this.ParentCommunicationID = ko.validatedObservable(settings.ParentCommunicationID);
        this.FileName = ko.validatedObservable(settings.FileName);
        this.CommunicationPriorityID = ko.validatedObservable(settings.CommunicationPriorityID);
        this.InitiatedByUserID = ko.validatedObservable(settings.InitiatedByUserID);
        this.InitiatedByGroupID = ko.validatedObservable(settings.InitiatedByGroupID);
        this.FulfilledByUserID = ko.validatedObservable(settings.FulfilledByUserID);
        this.FulfilledByGroupID = ko.validatedObservable(settings.FulfilledByGroupID);
        this.TargetUserID = ko.validatedObservable(settings.TargetUserID);
        this.ReadReceipt = ko.validatedObservable(settings.ReadReceipt);
        this.ActionTaken = ko.validatedObservable(settings.ActionTaken);
        this.ReadTrackingCode = ko.validatedObservable(settings.ReadTrackingCode);
        this.TrackingCode = ko.validatedObservable(settings.TrackingCode);
        this.BroadcastIdentifier = ko.validatedObservable(settings.BroadcastIdentifier);
        this.CommunicationStatusID = ko.validatedObservable(settings.CommunicationStatusID);
        this.StatusMessage = ko.validatedObservable(settings.StatusMessage);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.RelatedContact = ko.observable();
        this.ContactNotes = ko.observableArray([]);
        this.ParentCommunication = ko.observable();
        this.Parent = ko.observable();
        this.CommunicationStep = ko.observable();
        this.CommunicationType = ko.observable();
        this.Responses = ko.observableArray([]);
        this.EmbeddedAttachments = ko.observableArray([]);
        this.ExternalAttachments = ko.observableArray([]);
        this.RecipientList = ko.observableArray([]);
        this.CommunicationStatus = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Subject != undefined) {
                loaded.Subject(responseData.Subject);
            }
            if (responseData.FromAddress != undefined) {
                loaded.FromAddress(responseData.FromAddress);
            }
            if (responseData.ToAddress != undefined) {
                loaded.ToAddress(responseData.ToAddress);
            }
            if (responseData.FromDisplay != undefined) {
                loaded.FromDisplay(responseData.FromDisplay);
            }
            if (responseData.ToDisplay != undefined) {
                loaded.ToDisplay(responseData.ToDisplay);
            }
            if (responseData.Html != undefined) {
                loaded.Html(responseData.Html);
            }
            if (responseData.Fulfilled != undefined) {
                loaded.Fulfilled(responseData.Fulfilled);
            }
            if (responseData.FulfilledDate != undefined) {
                loaded.FulfilledDate(responseData.FulfilledDate);
            }
            if (responseData.WaitingForResponse != undefined) {
                loaded.WaitingForResponse(responseData.WaitingForResponse);
            }
            if (responseData.ReceivedResponse != undefined) {
                loaded.ReceivedResponse(responseData.ReceivedResponse);
            }
            if (responseData.ResponseDate != undefined) {
                loaded.ResponseDate(responseData.ResponseDate);
            }
            if (responseData.Received != undefined) {
                loaded.Received(responseData.Received);
            }
            if (responseData.ReceivedDate != undefined) {
                loaded.ReceivedDate(responseData.ReceivedDate);
            }
            if (responseData.InteractionPlanInstanceID != undefined) {
                loaded.InteractionPlanInstanceID(responseData.InteractionPlanInstanceID);
            }
            if (responseData.CommunicationTypeID != undefined) {
                loaded.CommunicationTypeID(responseData.CommunicationTypeID);
            }
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.RelatedContactID != undefined) {
                loaded.RelatedContactID(responseData.RelatedContactID);
            }
            if (responseData.CommunicationStepID != undefined) {
                loaded.CommunicationStepID(responseData.CommunicationStepID);
            }
            if (responseData.ParentCommunicationID != undefined) {
                loaded.ParentCommunicationID(responseData.ParentCommunicationID);
            }
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.CommunicationPriorityID != undefined) {
                loaded.CommunicationPriorityID(responseData.CommunicationPriorityID);
            }
            if (responseData.InitiatedByUserID != undefined) {
                loaded.InitiatedByUserID(responseData.InitiatedByUserID);
            }
            if (responseData.InitiatedByGroupID != undefined) {
                loaded.InitiatedByGroupID(responseData.InitiatedByGroupID);
            }
            if (responseData.FulfilledByUserID != undefined) {
                loaded.FulfilledByUserID(responseData.FulfilledByUserID);
            }
            if (responseData.FulfilledByGroupID != undefined) {
                loaded.FulfilledByGroupID(responseData.FulfilledByGroupID);
            }
            if (responseData.TargetUserID != undefined) {
                loaded.TargetUserID(responseData.TargetUserID);
            }
            if (responseData.ReadReceipt != undefined) {
                loaded.ReadReceipt(responseData.ReadReceipt);
            }
            if (responseData.ActionTaken != undefined) {
                loaded.ActionTaken(responseData.ActionTaken);
            }
            if (responseData.ReadTrackingCode != undefined) {
                loaded.ReadTrackingCode(responseData.ReadTrackingCode);
            }
            if (responseData.TrackingCode != undefined) {
                loaded.TrackingCode(responseData.TrackingCode);
            }
            if (responseData.BroadcastIdentifier != undefined) {
                loaded.BroadcastIdentifier(responseData.BroadcastIdentifier);
            }
            if (responseData.CommunicationStatusID != undefined) {
                loaded.CommunicationStatusID(responseData.CommunicationStatusID);
            }
            if (responseData.StatusMessage != undefined) {
                loaded.StatusMessage(responseData.StatusMessage);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.RelatedContact != null) {
                loaded.RelatedContact(new smapi.community.ContactModel().LoadFromResponse(responseData.RelatedContact));
            }
            if (responseData.ContactNotes != null && responseData.ContactNotes.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ContactNotes.length; i++) {
                    items.push(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.ContactNotes[i]));
                }
                loaded.ContactNotes(items);
            }
            if (responseData.ParentCommunication != null) {
                loaded.ParentCommunication(new smapi.communication.ContactCommunicationModel().LoadFromResponse(responseData.ParentCommunication));
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.communication.InteractionPlanInstanceModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.CommunicationStep != null) {
                loaded.CommunicationStep(new smapi.communication.CommunicationStepModel().LoadFromResponse(responseData.CommunicationStep));
            }
            if (responseData.CommunicationType != null) {
                loaded.CommunicationType(new smapi.communication.CommunicationTypeModel().LoadFromResponse(responseData.CommunicationType));
            }
            if (responseData.Responses != null && responseData.Responses.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Responses.length; i++) {
                    items.push(new smapi.communication.ContactCommunicationModel().LoadFromResponse(responseData.Responses[i]));
                }
                loaded.Responses(items);
            }
            if (responseData.EmbeddedAttachments != null && responseData.EmbeddedAttachments.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.EmbeddedAttachments.length; i++) {
                    items.push(new smapi.communication.ContactCommunicationEmbeddedAttachmentModel().LoadFromResponse(responseData.EmbeddedAttachments[i]));
                }
                loaded.EmbeddedAttachments(items);
            }
            if (responseData.ExternalAttachments != null && responseData.ExternalAttachments.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ExternalAttachments.length; i++) {
                    items.push(new smapi.communication.ContactCommunicationExternalAttachmentModel().LoadFromResponse(responseData.ExternalAttachments[i]));
                }
                loaded.ExternalAttachments(items);
            }
            if (responseData.RecipientList != null && responseData.RecipientList.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.RecipientList.length; i++) {
                    items.push(new smapi.communication.CommunicationRecipientDetailModel().LoadFromResponse(responseData.RecipientList[i]));
                }
                loaded.RecipientList(items);
            }
            if (responseData.CommunicationStatus != null) {
                loaded.CommunicationStatus(new smapi.communication.CommunicationStatusModel().LoadFromResponse(responseData.CommunicationStatus));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.ContactCommunication', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Subject.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FromAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ToAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FromDisplay.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ToDisplay.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Fulfilled.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.FulfilledDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.WaitingForResponse.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ReceivedResponse.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ResponseDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ReceivedDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanInstanceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelatedContactID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentCommunicationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FileName.extend({
            pattern: {
                params: /^(?:[\w]\:|\\|[\w\W])((\\*)[\w\W-[\\<>:\"\|\?\*]]+)+\.[\w\W-[\\<>:\"\|\?\*]]+$/,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_IncorrectFormat_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CommunicationPriorityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InitiatedByUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InitiatedByGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FulfilledByUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FulfilledByGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TargetUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReadTrackingCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.TrackingCode.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.BroadcastIdentifier.extend({
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.CommunicationStatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusMessage.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function ContactCommunicationEmbeddedAttachmentModel(options) {
        var defaults = {
            FileName: '',
            FileEncoding: '',
            FileSize: 0,
            MIMEType: '',
            FileData: null,
            AttachmentGID: null,
            ContactCommunicationID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.FileEncoding = ko.validatedObservable(settings.FileEncoding);
        this.FileSize = ko.validatedObservable(settings.FileSize);
        this.MIMEType = ko.validatedObservable(settings.MIMEType);
        this.FileData = ko.validatedObservable(settings.FileData);
        this.AttachmentGID = ko.validatedObservable(settings.AttachmentGID);
        this.ContactCommunicationID = ko.validatedObservable(settings.ContactCommunicationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.ContactCommunication = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.FileEncoding != undefined) {
                loaded.FileEncoding(responseData.FileEncoding);
            }
            if (responseData.FileSize != undefined) {
                loaded.FileSize(responseData.FileSize);
            }
            if (responseData.MIMEType != undefined) {
                loaded.MIMEType(responseData.MIMEType);
            }
            if (responseData.FileData != undefined) {
                loaded.FileData(responseData.FileData);
            }
            if (responseData.AttachmentGID != undefined) {
                loaded.AttachmentGID(responseData.AttachmentGID);
            }
            if (responseData.ContactCommunicationID != undefined) {
                loaded.ContactCommunicationID(responseData.ContactCommunicationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ContactCommunication != null) {
                loaded.ContactCommunication(new smapi.communication.ContactCommunicationModel().LoadFromResponse(responseData.ContactCommunication));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.ContactCommunicationEmbeddedAttachment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.FileEncoding.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FileSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MIMEType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.AttachmentGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContactCommunicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function ContactCommunicationExternalAttachmentModel(options) {
        var defaults = {
            FileName: '',
            ContactCommunicationID: null,
            CommunicationTemplateID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.ContactCommunicationID = ko.validatedObservable(settings.ContactCommunicationID);
        this.CommunicationTemplateID = ko.validatedObservable(settings.CommunicationTemplateID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.ContactCommunication = ko.observable();
        this.CommunicationTemplate = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.ContactCommunicationID != undefined) {
                loaded.ContactCommunicationID(responseData.ContactCommunicationID);
            }
            if (responseData.CommunicationTemplateID != undefined) {
                loaded.CommunicationTemplateID(responseData.CommunicationTemplateID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ContactCommunication != null) {
                loaded.ContactCommunication(new smapi.communication.ContactCommunicationModel().LoadFromResponse(responseData.ContactCommunication));
            }
            if (responseData.CommunicationTemplate != null) {
                loaded.CommunicationTemplate(new smapi.communication.CommunicationTemplateModel().LoadFromResponse(responseData.CommunicationTemplate));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.ContactCommunicationExternalAttachment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^(?:[\w]\:|\\|[\w\W])((\\*)[\w\W-[\\<>:\"\|\?\*]]+)+\.[\w\W-[\\<>:\"\|\?\*]]+$/,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_IncorrectFormat_Key)
            },
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.ContactCommunicationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function EmailTemplateModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EmbeddedImage: false,
            BeginDate: null,
            EndDate: null,
            Html: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EmbeddedImage = ko.validatedObservable(settings.EmbeddedImage);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.Html = ko.validatedObservable(settings.Html);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.EmbeddedAttachments = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EmbeddedImage != undefined) {
                loaded.EmbeddedImage(responseData.EmbeddedImage);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.Html != undefined) {
                loaded.Html(responseData.Html);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EmbeddedAttachments != null && responseData.EmbeddedAttachments.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.EmbeddedAttachments.length; i++) {
                    items.push(new smapi.communication.EmailTemplateEmbeddedAttachmentModel().LoadFromResponse(responseData.EmbeddedAttachments[i]));
                }
                loaded.EmbeddedAttachments(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.EmailTemplate', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EmbeddedImage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function EmailTemplateEmbeddedAttachmentModel(options) {
        var defaults = {
            FileName: '',
            FileEncoding: '',
            FileSize: 0,
            MIMEType: '',
            FileData: null,
            EmailTemplateID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.FileName = ko.validatedObservable(settings.FileName);
        this.FileEncoding = ko.validatedObservable(settings.FileEncoding);
        this.FileSize = ko.validatedObservable(settings.FileSize);
        this.MIMEType = ko.validatedObservable(settings.MIMEType);
        this.FileData = ko.validatedObservable(settings.FileData);
        this.EmailTemplateID = ko.validatedObservable(settings.EmailTemplateID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.EmailTemplate = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.FileEncoding != undefined) {
                loaded.FileEncoding(responseData.FileEncoding);
            }
            if (responseData.FileSize != undefined) {
                loaded.FileSize(responseData.FileSize);
            }
            if (responseData.MIMEType != undefined) {
                loaded.MIMEType(responseData.MIMEType);
            }
            if (responseData.FileData != undefined) {
                loaded.FileData(responseData.FileData);
            }
            if (responseData.EmailTemplateID != undefined) {
                loaded.EmailTemplateID(responseData.EmailTemplateID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EmailTemplate != null) {
                loaded.EmailTemplate(new smapi.communication.EmailTemplateModel().LoadFromResponse(responseData.EmailTemplate));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.EmailTemplateEmbeddedAttachment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 1024,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1024')
            }
        });
        this.FileEncoding.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.FileSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MIMEType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EmailTemplateID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionPlanModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EffectiveDate: null,
            EndDate: null,
            EndDurationFromStart: null,
            EntityID: 0,
            FulfillByUserID: null,
            FulfillByGroupID: null,
            StartingRuleSetID: null,
            PlanTestMode: false,
            BusinessMeaningName: '',
            ModuleID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EffectiveDate = ko.validatedObservable(settings.EffectiveDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.EndDurationFromStart = ko.validatedObservable(settings.EndDurationFromStart);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.FulfillByUserID = ko.validatedObservable(settings.FulfillByUserID);
        this.FulfillByGroupID = ko.validatedObservable(settings.FulfillByGroupID);
        this.StartingRuleSetID = ko.validatedObservable(settings.StartingRuleSetID);
        this.PlanTestMode = ko.validatedObservable(settings.PlanTestMode);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ModuleID = ko.validatedObservable(settings.ModuleID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionSteps = ko.observableArray([]);
        this.InteractionPlanPriority = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EffectiveDate != undefined) {
                loaded.EffectiveDate(responseData.EffectiveDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.EndDurationFromStart != undefined) {
                loaded.EndDurationFromStart(responseData.EndDurationFromStart);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.FulfillByUserID != undefined) {
                loaded.FulfillByUserID(responseData.FulfillByUserID);
            }
            if (responseData.FulfillByGroupID != undefined) {
                loaded.FulfillByGroupID(responseData.FulfillByGroupID);
            }
            if (responseData.StartingRuleSetID != undefined) {
                loaded.StartingRuleSetID(responseData.StartingRuleSetID);
            }
            if (responseData.PlanTestMode != undefined) {
                loaded.PlanTestMode(responseData.PlanTestMode);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ModuleID != undefined) {
                loaded.ModuleID(responseData.ModuleID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionSteps != null && responseData.InteractionSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.InteractionSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.InteractionSteps[i]));
                }
                loaded.InteractionSteps(items);
            }
            if (responseData.InteractionPlanPriority != null && responseData.InteractionPlanPriority.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.InteractionPlanPriority.length; i++) {
                    items.push(new smapi.communication.InteractionPlanPriorityModel().LoadFromResponse(responseData.InteractionPlanPriority[i]));
                }
                loaded.InteractionPlanPriority(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionPlan', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EffectiveDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FulfillByUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FulfillByGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartingRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PlanTestMode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionPlanGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CanStartRuleID: 0,
            StartRuleID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CanStartRuleID = ko.validatedObservable(settings.CanStartRuleID);
        this.StartRuleID = ko.validatedObservable(settings.StartRuleID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlanGroupRule = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CanStartRuleID != undefined) {
                loaded.CanStartRuleID(responseData.CanStartRuleID);
            }
            if (responseData.StartRuleID != undefined) {
                loaded.StartRuleID(responseData.StartRuleID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlanGroupRule != null && responseData.InteractionPlanGroupRule.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.InteractionPlanGroupRule.length; i++) {
                    items.push(new smapi.communication.InteractionPlanGroupRuleModel().LoadFromResponse(responseData.InteractionPlanGroupRule[i]));
                }
                loaded.InteractionPlanGroupRule(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionPlanGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CanStartRuleID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartRuleID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionPlanGroupRuleModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Singleton: false,
            Replace: false,
            InteractionPlanGroupID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Singleton = ko.validatedObservable(settings.Singleton);
        this.Replace = ko.validatedObservable(settings.Replace);
        this.InteractionPlanGroupID = ko.validatedObservable(settings.InteractionPlanGroupID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlanPriorities = ko.observableArray([]);
        this.InteractionPlanGroup = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Singleton != undefined) {
                loaded.Singleton(responseData.Singleton);
            }
            if (responseData.Replace != undefined) {
                loaded.Replace(responseData.Replace);
            }
            if (responseData.InteractionPlanGroupID != undefined) {
                loaded.InteractionPlanGroupID(responseData.InteractionPlanGroupID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlanPriorities != null && responseData.InteractionPlanPriorities.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.InteractionPlanPriorities.length; i++) {
                    items.push(new smapi.communication.InteractionPlanPriorityModel().LoadFromResponse(responseData.InteractionPlanPriorities[i]));
                }
                loaded.InteractionPlanPriorities(items);
            }
            if (responseData.InteractionPlanGroup != null) {
                loaded.InteractionPlanGroup(new smapi.communication.InteractionPlanGroupModel().LoadFromResponse(responseData.InteractionPlanGroup));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionPlanGroupRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Singleton.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Replace.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InteractionPlanGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionPlanInstanceModel(options) {
        var defaults = {
            WorkflowInstanceID: null,
            ContextEntityID: null,
            ContextEntityName: '',
            ContextEntityGID: null,
            StartDate: null,
            TargetEndDate: null,
            EndDate: null,
            ContactID: 0,
            InteractionPlanID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.WorkflowInstanceID = ko.validatedObservable(settings.WorkflowInstanceID);
        this.ContextEntityID = ko.validatedObservable(settings.ContextEntityID);
        this.ContextEntityName = ko.validatedObservable(settings.ContextEntityName);
        this.ContextEntityGID = ko.validatedObservable(settings.ContextEntityGID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.TargetEndDate = ko.validatedObservable(settings.TargetEndDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.InteractionPlan = ko.observable();
        this.Communications = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.WorkflowInstanceID != undefined) {
                loaded.WorkflowInstanceID(responseData.WorkflowInstanceID);
            }
            if (responseData.ContextEntityID != undefined) {
                loaded.ContextEntityID(responseData.ContextEntityID);
            }
            if (responseData.ContextEntityName != undefined) {
                loaded.ContextEntityName(responseData.ContextEntityName);
            }
            if (responseData.ContextEntityGID != undefined) {
                loaded.ContextEntityGID(responseData.ContextEntityGID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.TargetEndDate != undefined) {
                loaded.TargetEndDate(responseData.TargetEndDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.Communications != null && responseData.Communications.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Communications.length; i++) {
                    items.push(new smapi.communication.ContactCommunicationModel().LoadFromResponse(responseData.Communications[i]));
                }
                loaded.Communications(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionPlanInstance', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.WorkflowInstanceID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContextEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContextEntityName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ContextEntityGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.TargetEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionPlanID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionPlanPriorityModel(options) {
        var defaults = {
            InteractionPlanID: null,
            Priority: 0,
            InteractionPlanGroupRuleID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.Priority = ko.validatedObservable(settings.Priority);
        this.InteractionPlanGroupRuleID = ko.validatedObservable(settings.InteractionPlanGroupRuleID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlanGroupRule = ko.observable();
        this.InteractionPlan = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.Priority != undefined) {
                loaded.Priority(responseData.Priority);
            }
            if (responseData.InteractionPlanGroupRuleID != undefined) {
                loaded.InteractionPlanGroupRuleID(responseData.InteractionPlanGroupRuleID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlanGroupRule != null) {
                loaded.InteractionPlanGroupRule(new smapi.communication.InteractionPlanGroupRuleModel().LoadFromResponse(responseData.InteractionPlanGroupRule));
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionPlanPriority', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Priority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionPlanGroupRuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function InteractionStepModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            InteractionStepType: null,
            DurationBeforeExecution: null,
            BeginDate: null,
            EndDate: null,
            InteractionPlanID: null,
            ParentStepID: null,
            InclusionRuleSetID: null,
            BusinessMeaningName: '',
            PathToRecipient: '',
            PathToRecipientExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.InteractionStepType = ko.validatedObservable(settings.InteractionStepType);
        this.DurationBeforeExecution = ko.validatedObservable(settings.DurationBeforeExecution);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PathToRecipient = ko.validatedObservable(settings.PathToRecipient);
        this.PathToRecipientExpressionID = ko.validatedObservable(settings.PathToRecipientExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlan = ko.observable();
        this.ParentStep = ko.observable();
        this.ChildSteps = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.InteractionStepType != undefined) {
                loaded.InteractionStepType(responseData.InteractionStepType);
            }
            if (responseData.DurationBeforeExecution != undefined) {
                loaded.DurationBeforeExecution(responseData.DurationBeforeExecution);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PathToRecipient != undefined) {
                loaded.PathToRecipient(responseData.PathToRecipient);
            }
            if (responseData.PathToRecipientExpressionID != undefined) {
                loaded.PathToRecipientExpressionID(responseData.PathToRecipientExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.ParentStep != null) {
                loaded.ParentStep(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ParentStep));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.InteractionStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionStepType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToRecipient.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToRecipientExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function MeetingStepModel(options) {
        var defaults = {
            Subject: '',
            Instructions: '',
            ConfigurationRuleSetID: null,
            Name: '',
            Description: '',
            SortOrder: 0,
            InteractionStepType: null,
            DurationBeforeExecution: null,
            BeginDate: null,
            EndDate: null,
            InteractionPlanID: null,
            ParentStepID: null,
            InclusionRuleSetID: null,
            BusinessMeaningName: '',
            PathToRecipient: '',
            PathToRecipientExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Subject = ko.validatedObservable(settings.Subject);
        this.Instructions = ko.validatedObservable(settings.Instructions);
        this.ConfigurationRuleSetID = ko.validatedObservable(settings.ConfigurationRuleSetID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.InteractionStepType = ko.validatedObservable(settings.InteractionStepType);
        this.DurationBeforeExecution = ko.validatedObservable(settings.DurationBeforeExecution);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PathToRecipient = ko.validatedObservable(settings.PathToRecipient);
        this.PathToRecipientExpressionID = ko.validatedObservable(settings.PathToRecipientExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlan = ko.observable();
        this.ParentStep = ko.observable();
        this.ChildSteps = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Subject != undefined) {
                loaded.Subject(responseData.Subject);
            }
            if (responseData.Instructions != undefined) {
                loaded.Instructions(responseData.Instructions);
            }
            if (responseData.ConfigurationRuleSetID != undefined) {
                loaded.ConfigurationRuleSetID(responseData.ConfigurationRuleSetID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.InteractionStepType != undefined) {
                loaded.InteractionStepType(responseData.InteractionStepType);
            }
            if (responseData.DurationBeforeExecution != undefined) {
                loaded.DurationBeforeExecution(responseData.DurationBeforeExecution);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PathToRecipient != undefined) {
                loaded.PathToRecipient(responseData.PathToRecipient);
            }
            if (responseData.PathToRecipientExpressionID != undefined) {
                loaded.PathToRecipientExpressionID(responseData.PathToRecipientExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.ParentStep != null) {
                loaded.ParentStep(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ParentStep));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.MeetingStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Subject.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Instructions.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.ConfigurationRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionStepType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToRecipient.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToRecipientExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsDocumentModel(options) {
        var defaults = {
            Title: '',
            DateFrom: null,
            DateTo: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Title = ko.validatedObservable(settings.Title);
        this.DateFrom = ko.validatedObservable(settings.DateFrom);
        this.DateTo = ko.validatedObservable(settings.DateTo);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Paragraphs = ko.observableArray([]);
        this.Conditions = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.DateFrom != undefined) {
                loaded.DateFrom(responseData.DateFrom);
            }
            if (responseData.DateTo != undefined) {
                loaded.DateTo(responseData.DateTo);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Paragraphs != null && responseData.Paragraphs.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Paragraphs.length; i++) {
                    items.push(new smapi.communication.TermsConditionsDocumentParagraphPropertiesModel().LoadFromResponse(responseData.Paragraphs[i]));
                }
                loaded.Paragraphs(items);
            }
            if (responseData.Conditions != null && responseData.Conditions.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Conditions.length; i++) {
                    items.push(new smapi.communication.TermsConditionsDocumentCriteriaModel().LoadFromResponse(responseData.Conditions[i]));
                }
                loaded.Conditions(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsDocument', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DateFrom.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsDocumentCriteriaModel(options) {
        var defaults = {
            DocumentID: 0,
            LocationID: 0,
            ProcessTypeID: 0,
            CriteriaRulesetID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.DocumentID = ko.validatedObservable(settings.DocumentID);
        this.LocationID = ko.validatedObservable(settings.LocationID);
        this.ProcessTypeID = ko.validatedObservable(settings.ProcessTypeID);
        this.CriteriaRulesetID = ko.validatedObservable(settings.CriteriaRulesetID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Document = ko.observable();
        this.Location = ko.observable();
        this.ProcessType = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.DocumentID != undefined) {
                loaded.DocumentID(responseData.DocumentID);
            }
            if (responseData.LocationID != undefined) {
                loaded.LocationID(responseData.LocationID);
            }
            if (responseData.ProcessTypeID != undefined) {
                loaded.ProcessTypeID(responseData.ProcessTypeID);
            }
            if (responseData.CriteriaRulesetID != undefined) {
                loaded.CriteriaRulesetID(responseData.CriteriaRulesetID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Document != null) {
                loaded.Document(new smapi.communication.TermsConditionsDocumentModel().LoadFromResponse(responseData.Document));
            }
            if (responseData.Location != null) {
                loaded.Location(new smapi.communication.TermsConditionsLocationModel().LoadFromResponse(responseData.Location));
            }
            if (responseData.ProcessType != null) {
                loaded.ProcessType(new smapi.communication.TermsConditionsProcessTypeModel().LoadFromResponse(responseData.ProcessType));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsDocumentCriteria', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.DocumentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LocationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CriteriaRulesetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsDocumentParagraphPropertiesModel(options) {
        var defaults = {
            DateFrom: null,
            DateTo: null,
            IsRequired: false,
            IsRevocable: false,
            SortOrder: 0,
            Version: 0,
            TermsConditionsDocumentID: 0,
            TermsConditionsParagraphID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.DateFrom = ko.validatedObservable(settings.DateFrom);
        this.DateTo = ko.validatedObservable(settings.DateTo);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.IsRevocable = ko.validatedObservable(settings.IsRevocable);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Version = ko.validatedObservable(settings.Version);
        this.TermsConditionsDocumentID = ko.validatedObservable(settings.TermsConditionsDocumentID);
        this.TermsConditionsParagraphID = ko.validatedObservable(settings.TermsConditionsParagraphID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.TermsConditionsDocument = ko.observable();
        this.TermsConditionsParagraph = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.DateFrom != undefined) {
                loaded.DateFrom(responseData.DateFrom);
            }
            if (responseData.DateTo != undefined) {
                loaded.DateTo(responseData.DateTo);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.IsRevocable != undefined) {
                loaded.IsRevocable(responseData.IsRevocable);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.TermsConditionsDocumentID != undefined) {
                loaded.TermsConditionsDocumentID(responseData.TermsConditionsDocumentID);
            }
            if (responseData.TermsConditionsParagraphID != undefined) {
                loaded.TermsConditionsParagraphID(responseData.TermsConditionsParagraphID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TermsConditionsDocument != null) {
                loaded.TermsConditionsDocument(new smapi.communication.TermsConditionsDocumentModel().LoadFromResponse(responseData.TermsConditionsDocument));
            }
            if (responseData.TermsConditionsParagraph != null) {
                loaded.TermsConditionsParagraph(new smapi.communication.TermsConditionsParagraphModel().LoadFromResponse(responseData.TermsConditionsParagraph));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsDocumentParagraphProperties', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.DateFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.IsRequired.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.IsRevocable.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Version.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsDocumentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsParagraphID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsDocumentStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsDocumentStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsExposedDocumentModel(options) {
        var defaults = {
            IsAccepted: false,
            ProcessObjectID: 0,
            ObjectDescription: '',
            LocationID: 0,
            TermsConditionsDocumentID: 0,
            PersonID: null,
            ProcessTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.IsAccepted = ko.validatedObservable(settings.IsAccepted);
        this.ProcessObjectID = ko.validatedObservable(settings.ProcessObjectID);
        this.ObjectDescription = ko.validatedObservable(settings.ObjectDescription);
        this.LocationID = ko.validatedObservable(settings.LocationID);
        this.TermsConditionsDocumentID = ko.validatedObservable(settings.TermsConditionsDocumentID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ProcessTypeID = ko.validatedObservable(settings.ProcessTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Location = ko.observable();
        this.TermsConditionsDocument = ko.observable();
        this.Person = ko.observable();
        this.ProcessType = ko.observable();
        this.Paragraphs = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.IsAccepted != undefined) {
                loaded.IsAccepted(responseData.IsAccepted);
            }
            if (responseData.ProcessObjectID != undefined) {
                loaded.ProcessObjectID(responseData.ProcessObjectID);
            }
            if (responseData.ObjectDescription != undefined) {
                loaded.ObjectDescription(responseData.ObjectDescription);
            }
            if (responseData.LocationID != undefined) {
                loaded.LocationID(responseData.LocationID);
            }
            if (responseData.TermsConditionsDocumentID != undefined) {
                loaded.TermsConditionsDocumentID(responseData.TermsConditionsDocumentID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ProcessTypeID != undefined) {
                loaded.ProcessTypeID(responseData.ProcessTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Location != null) {
                loaded.Location(new smapi.communication.TermsConditionsLocationModel().LoadFromResponse(responseData.Location));
            }
            if (responseData.TermsConditionsDocument != null) {
                loaded.TermsConditionsDocument(new smapi.communication.TermsConditionsDocumentModel().LoadFromResponse(responseData.TermsConditionsDocument));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.ProcessType != null) {
                loaded.ProcessType(new smapi.communication.TermsConditionsProcessTypeModel().LoadFromResponse(responseData.ProcessType));
            }
            if (responseData.Paragraphs != null && responseData.Paragraphs.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.Paragraphs.length; i++) {
                    items.push(new smapi.communication.TermsConditionsHistoryModel().LoadFromResponse(responseData.Paragraphs[i]));
                }
                loaded.Paragraphs(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsExposedDocument', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.IsAccepted.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ProcessObjectID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ObjectDescription.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.LocationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsDocumentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsHistoryModel(options) {
        var defaults = {
            IsAccepted: false,
            IsLatest: false,
            TermsConditionsParagraphVersionID: 0,
            TermsConditionsDocumentParagraphPropertiesID: null,
            TermsConditionsExposedDocumentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.IsAccepted = ko.validatedObservable(settings.IsAccepted);
        this.IsLatest = ko.validatedObservable(settings.IsLatest);
        this.TermsConditionsParagraphVersionID = ko.validatedObservable(settings.TermsConditionsParagraphVersionID);
        this.TermsConditionsDocumentParagraphPropertiesID = ko.validatedObservable(settings.TermsConditionsDocumentParagraphPropertiesID);
        this.TermsConditionsExposedDocumentID = ko.validatedObservable(settings.TermsConditionsExposedDocumentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.TermsConditionsParagraphVersion = ko.observable();
        this.TermsConditionsDocumentParagraphProperties = ko.observable();
        this.TermsConditionsExposedDocument = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.IsAccepted != undefined) {
                loaded.IsAccepted(responseData.IsAccepted);
            }
            if (responseData.IsLatest != undefined) {
                loaded.IsLatest(responseData.IsLatest);
            }
            if (responseData.TermsConditionsParagraphVersionID != undefined) {
                loaded.TermsConditionsParagraphVersionID(responseData.TermsConditionsParagraphVersionID);
            }
            if (responseData.TermsConditionsDocumentParagraphPropertiesID != undefined) {
                loaded.TermsConditionsDocumentParagraphPropertiesID(responseData.TermsConditionsDocumentParagraphPropertiesID);
            }
            if (responseData.TermsConditionsExposedDocumentID != undefined) {
                loaded.TermsConditionsExposedDocumentID(responseData.TermsConditionsExposedDocumentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TermsConditionsParagraphVersion != null) {
                loaded.TermsConditionsParagraphVersion(new smapi.communication.TermsConditionsParagraphVersionModel().LoadFromResponse(responseData.TermsConditionsParagraphVersion));
            }
            if (responseData.TermsConditionsDocumentParagraphProperties != null) {
                loaded.TermsConditionsDocumentParagraphProperties(new smapi.communication.TermsConditionsDocumentParagraphPropertiesModel().LoadFromResponse(responseData.TermsConditionsDocumentParagraphProperties));
            }
            if (responseData.TermsConditionsExposedDocument != null) {
                loaded.TermsConditionsExposedDocument(new smapi.communication.TermsConditionsExposedDocumentModel().LoadFromResponse(responseData.TermsConditionsExposedDocument));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsHistory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.IsAccepted.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.IsLatest.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TermsConditionsParagraphVersionID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsDocumentParagraphPropertiesID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsExposedDocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsLocationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsLocation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsParagraphModel(options) {
        var defaults = {
            Title: '',
            TermsConditionsParagraphTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Title = ko.validatedObservable(settings.Title);
        this.TermsConditionsParagraphTypeID = ko.validatedObservable(settings.TermsConditionsParagraphTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.TermsConditionsParagraphType = ko.observable();
        this.TermsConditionsParagraphVersions = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.TermsConditionsParagraphTypeID != undefined) {
                loaded.TermsConditionsParagraphTypeID(responseData.TermsConditionsParagraphTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TermsConditionsParagraphType != null) {
                loaded.TermsConditionsParagraphType(new smapi.communication.TermsConditionsParagraphTypeModel().LoadFromResponse(responseData.TermsConditionsParagraphType));
            }
            if (responseData.TermsConditionsParagraphVersions != null && responseData.TermsConditionsParagraphVersions.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.TermsConditionsParagraphVersions.length; i++) {
                    items.push(new smapi.communication.TermsConditionsParagraphVersionModel().LoadFromResponse(responseData.TermsConditionsParagraphVersions[i]));
                }
                loaded.TermsConditionsParagraphVersions(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsParagraph', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TermsConditionsParagraphTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsParagraphTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsParagraphType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsParagraphVersionModel(options) {
        var defaults = {
            DateFrom: null,
            DateTo: null,
            HTMLContent: '',
            TermsConditionsParagraphID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.DateFrom = ko.validatedObservable(settings.DateFrom);
        this.DateTo = ko.validatedObservable(settings.DateTo);
        this.HTMLContent = ko.validatedObservable(settings.HTMLContent);
        this.TermsConditionsParagraphID = ko.validatedObservable(settings.TermsConditionsParagraphID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.TermsConditionsParagraph = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.DateFrom != undefined) {
                loaded.DateFrom(responseData.DateFrom);
            }
            if (responseData.DateTo != undefined) {
                loaded.DateTo(responseData.DateTo);
            }
            if (responseData.HTMLContent != undefined) {
                loaded.HTMLContent(responseData.HTMLContent);
            }
            if (responseData.TermsConditionsParagraphID != undefined) {
                loaded.TermsConditionsParagraphID(responseData.TermsConditionsParagraphID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TermsConditionsParagraph != null) {
                loaded.TermsConditionsParagraph(new smapi.communication.TermsConditionsParagraphModel().LoadFromResponse(responseData.TermsConditionsParagraph));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsParagraphVersion', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.DateFrom.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.TermsConditionsParagraphID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TermsConditionsProcessTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsProcessType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function ToDoStepModel(options) {
        var defaults = {
            TaskBeginDate: null,
            TaskEndDate: null,
            TaskPriority: 0,
            DurationBeforeDueDate: null,
            Name: '',
            Description: '',
            SortOrder: 0,
            InteractionStepType: null,
            DurationBeforeExecution: null,
            BeginDate: null,
            EndDate: null,
            InteractionPlanID: null,
            ParentStepID: null,
            InclusionRuleSetID: null,
            BusinessMeaningName: '',
            PathToRecipient: '',
            PathToRecipientExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.TaskBeginDate = ko.validatedObservable(settings.TaskBeginDate);
        this.TaskEndDate = ko.validatedObservable(settings.TaskEndDate);
        this.TaskPriority = ko.validatedObservable(settings.TaskPriority);
        this.DurationBeforeDueDate = ko.validatedObservable(settings.DurationBeforeDueDate);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.InteractionStepType = ko.validatedObservable(settings.InteractionStepType);
        this.DurationBeforeExecution = ko.validatedObservable(settings.DurationBeforeExecution);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.InteractionPlanID = ko.validatedObservable(settings.InteractionPlanID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PathToRecipient = ko.validatedObservable(settings.PathToRecipient);
        this.PathToRecipientExpressionID = ko.validatedObservable(settings.PathToRecipientExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.InteractionPlan = ko.observable();
        this.ParentStep = ko.observable();
        this.ChildSteps = ko.observableArray([]);

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.TaskBeginDate != undefined) {
                loaded.TaskBeginDate(responseData.TaskBeginDate);
            }
            if (responseData.TaskEndDate != undefined) {
                loaded.TaskEndDate(responseData.TaskEndDate);
            }
            if (responseData.TaskPriority != undefined) {
                loaded.TaskPriority(responseData.TaskPriority);
            }
            if (responseData.DurationBeforeDueDate != undefined) {
                loaded.DurationBeforeDueDate(responseData.DurationBeforeDueDate);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.InteractionStepType != undefined) {
                loaded.InteractionStepType(responseData.InteractionStepType);
            }
            if (responseData.DurationBeforeExecution != undefined) {
                loaded.DurationBeforeExecution(responseData.DurationBeforeExecution);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.InteractionPlanID != undefined) {
                loaded.InteractionPlanID(responseData.InteractionPlanID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PathToRecipient != undefined) {
                loaded.PathToRecipient(responseData.PathToRecipient);
            }
            if (responseData.PathToRecipientExpressionID != undefined) {
                loaded.PathToRecipientExpressionID(responseData.PathToRecipientExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InteractionPlan != null) {
                loaded.InteractionPlan(new smapi.communication.InteractionPlanModel().LoadFromResponse(responseData.InteractionPlan));
            }
            if (responseData.ParentStep != null) {
                loaded.ParentStep(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ParentStep));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.communication.InteractionStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.ToDoStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.TaskBeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.TaskEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.TaskPriority.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InteractionStepType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.InteractionPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PathToRecipient.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PathToRecipientExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function TokenMergeModel(options) {
        var defaults = {
            ContactCommunicationID: 0,
            CommunicationTemplateID: 0,
            Token: '',
            Value: '',
            MergeEngine: '',
            IsProcessing: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.ContactCommunicationID = ko.validatedObservable(settings.ContactCommunicationID);
        this.CommunicationTemplateID = ko.validatedObservable(settings.CommunicationTemplateID);
        this.Token = ko.validatedObservable(settings.Token);
        this.Value = ko.validatedObservable(settings.Value);
        this.MergeEngine = ko.validatedObservable(settings.MergeEngine);
        this.IsProcessing = ko.validatedObservable(settings.IsProcessing);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.ContactCommunicationID != undefined) {
                loaded.ContactCommunicationID(responseData.ContactCommunicationID);
            }
            if (responseData.CommunicationTemplateID != undefined) {
                loaded.CommunicationTemplateID(responseData.CommunicationTemplateID);
            }
            if (responseData.Token != undefined) {
                loaded.Token(responseData.Token);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.MergeEngine != undefined) {
                loaded.MergeEngine(responseData.MergeEngine);
            }
            if (responseData.IsProcessing != undefined) {
                loaded.IsProcessing(responseData.IsProcessing);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TokenMerge', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.ContactCommunicationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommunicationTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Token.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MergeEngine.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.IsProcessing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function LoadTemplates(basePath, targetDiv) {
        var uri = basePath + '/SMAPI.communication.combined-1.0.0.html';
        jQuery.ajax({
            url: uri,
            type: 'GET',
            async: false,
            success: function (template) {
                jQuery("#" + targetDiv).append(template);
            }
        });
    }


    $.extend(true, smapi.communication, {
        AddressTypeAssociationPriorityModel: AddressTypeAssociationPriorityModel,
        CampusVisitStepModel: CampusVisitStepModel,
        CommunicationFulfillmentFolderModel: CommunicationFulfillmentFolderModel,
        CommunicationRecipientDetailModel: CommunicationRecipientDetailModel,
        CommunicationStatusModel: CommunicationStatusModel,
        CommunicationStepModel: CommunicationStepModel,
        CommunicationTemplateModel: CommunicationTemplateModel,
        CommunicationTemplateEmbeddedAttachmentModel: CommunicationTemplateEmbeddedAttachmentModel,
        CommunicationTokenModel: CommunicationTokenModel,
        CommunicationTrackingModel: CommunicationTrackingModel,
        CommunicationTypeModel: CommunicationTypeModel,
        ContactCommunicationModel: ContactCommunicationModel,
        ContactCommunicationEmbeddedAttachmentModel: ContactCommunicationEmbeddedAttachmentModel,
        ContactCommunicationExternalAttachmentModel: ContactCommunicationExternalAttachmentModel,
        EmailTemplateModel: EmailTemplateModel,
        EmailTemplateEmbeddedAttachmentModel: EmailTemplateEmbeddedAttachmentModel,
        InteractionPlanModel: InteractionPlanModel,
        InteractionPlanGroupModel: InteractionPlanGroupModel,
        InteractionPlanGroupRuleModel: InteractionPlanGroupRuleModel,
        InteractionPlanInstanceModel: InteractionPlanInstanceModel,
        InteractionPlanPriorityModel: InteractionPlanPriorityModel,
        InteractionStepModel: InteractionStepModel,
        MeetingStepModel: MeetingStepModel,
        TermsConditionsDocumentModel: TermsConditionsDocumentModel,
        TermsConditionsDocumentCriteriaModel: TermsConditionsDocumentCriteriaModel,
        TermsConditionsDocumentParagraphPropertiesModel: TermsConditionsDocumentParagraphPropertiesModel,
        TermsConditionsDocumentStatusModel: TermsConditionsDocumentStatusModel,
        TermsConditionsExposedDocumentModel: TermsConditionsExposedDocumentModel,
        TermsConditionsHistoryModel: TermsConditionsHistoryModel,
        TermsConditionsLocationModel: TermsConditionsLocationModel,
        TermsConditionsParagraphModel: TermsConditionsParagraphModel,
        TermsConditionsParagraphTypeModel: TermsConditionsParagraphTypeModel,
        TermsConditionsParagraphVersionModel: TermsConditionsParagraphVersionModel,
        TermsConditionsProcessTypeModel: TermsConditionsProcessTypeModel,
        ToDoStepModel: ToDoStepModel,
        TokenMergeModel: TokenMergeModel,
        LoadTemplates: LoadTemplates
    });
})(jQuery);
